export default class AuthStore {
  isLoggedIn = false;
}
